// M2 — Content & Attributes testids
export const CONTENT = {
  navLink: "nav-content-link",
  // Brand Content page
  pageRoot: "content-page-root",
  newCategoryButton: "content-new-category-button",
  newCategoryName: "content-new-category-name-input",
  newCategorySlug: "content-new-category-slug-input",
  newCategoryDesc: "content-new-category-desc-input",
  newCategorySubmit: "content-new-category-submit",
  newCategoryCancel: "content-new-category-cancel",
  categoryRowPrefix: "content-category-row-",

  // Category detail
  catDetailRoot: "content-category-root",
  catSchemaTab: "content-category-schema-tab",
  catItemsTab: "content-category-items-tab",
  catFieldRowPrefix: "content-field-row-",
  catFieldAddButton: "content-field-add-button",
  catFieldKey: "content-field-key-",
  catFieldName: "content-field-name-",
  catFieldType: "content-field-type-",
  catFieldRequired: "content-field-required-",
  catFieldRemove: "content-field-remove-",
  catSchemaSave: "content-schema-save",
  catNewItemButton: "content-new-item-button",
  catItemRowPrefix: "content-item-row-",

  // Item editor
  itemRoot: "content-item-root",
  itemName: "content-item-name-input",
  itemFieldPrefix: "content-item-field-",
  itemSave: "content-item-save",
  itemDelete: "content-item-delete",
};

export const ATTRIBUTES = {
  pageRoot: "attributes-page-root",
  // schema editor reuses the same fieldset UX as content
  saveSchema: "attributes-schema-save",
  fieldRowPrefix: "attributes-field-row-",
  // per-entity values editor
  valuesRoot: "attributes-values-root",
  valueFieldPrefix: "attributes-value-field-",
  valuesSave: "attributes-values-save",
};

export const FILES = {
  upload: "file-upload-input",
  uploadButton: "file-upload-button",
  clearButton: "file-clear-button",
};
